import type React from 'react';

export const DEFAULT_FLAG_STYLE: React.CSSProperties = { marginLeft: 4, marginRight: 12 };
